// @ts-nocheck
import MaskedInput from 'react-text-mask';

import type { InputProps } from '@material-ui/core/Input';

import Input from '../Input/Input';

interface CustomHourInputProps extends InputProps {
  error?: boolean;
  placeholder?: string;
  inputRef?: (ref?: HTMLElement) => void;
}

export const InputTime = (props: CustomHourInputProps) => {
  const timeMask = (rawValue: string) => {
    const chars = rawValue.split('');
    const hours = [/[0-2]/, chars[0] === '2' ? /[0-3]/ : /[0-9]/];
    const minutes = [/[0-5]/, /[0-9]/];
    return [...hours, ':', ...minutes];
  };

  const { placeholder, inputRef, value, defaultValue, ...otherProps } = props;

  return (
    <MaskedInput
      {...otherProps}
      render={(ref, props) => <Input ref={ref} {...props} />}
      value={value as string}
      defaultValue={defaultValue as string}
      mask={timeMask}
      placeholder={placeholder || '00h00'}
      placeholderChar={'\u2000'}
      guide
    />
  );
};
